import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { yandexLogin } from '../services/api';
import { useUser } from '../context/UserContext';
import SetUsername from '../pages/Auth/SetUsername';
import { initVkConfig, sendVkUserToBackend } from '../utils/vkConfig';
import { consumeYandexState } from '../utils/oauthState';
import { authDestination } from '../utils/authDestination';

const VkAuthHandler = ({ children }) => {
  const navigate = useNavigate();
  const { refreshUser, setUser } = useUser();
  const [showSetUsername, setShowSetUsername] = useState(false);
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (!code) return;
    processedRef.current = true;

    window.history.replaceState({}, document.title, window.location.pathname);

    const token = localStorage.getItem('polka_token');
    if (token) { navigate(authDestination()); return; }

    const redirectUri = window.location.origin;
    const deviceId = urlParams.get('device_id');

    const login = deviceId ? initVkConfig().then(({ Auth }) => Auth.exchangeCode(code, deviceId))
      .then((payload) => {
        if (!payload || !payload.access_token) {
          throw new Error('No VK access token');
        }
        return sendVkUserToBackend(payload);
      })
      : consumeYandexState(urlParams.get('state'))
        ? yandexLogin(code, redirectUri)
        : Promise.reject(new Error('Неверная или просроченная сессия входа'));

    login
      .then((data) => {
        if (data?.token) localStorage.setItem('polka_token', data.token);
        if (data?.user) setUser(data.user);
        if (data?.requires_username) setShowSetUsername(true);
        else refreshUser().then(() => navigate(authDestination()));
      })
      .catch(() => {
        alert('Не удалось выполнить вход. Попробуйте ещё раз.');
        navigate('/login');
      });
  }, [navigate, refreshUser, setUser]);

  const handleSetUsernameComplete = (result) => {
    setShowSetUsername(false);
    if (result?.token) localStorage.setItem('polka_token', result.token);
    refreshUser().then(() => navigate(authDestination()));
  };

  return (
    <>
      {showSetUsername && <SetUsername onComplete={handleSetUsernameComplete} />}
      {children}
    </>
  );
};

export default VkAuthHandler;
